const capitalize = (word = '') => {
  return `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`;
};

export const urlTitle = path => {
  return path
    .split(/\/|-/)
    .map(w => capitalize(w))
    .join(' ')
    .trim();
};



// WEBPACK FOOTER //
// ./src/utils/formatters.js